export enum EventBundlePublishingState {
	Draft = 'draft',
	Published = 'published',
	WaitingForAdminApproval = 'waiting-for-admin-approval',
	WaitingForStripeApproval = 'waiting-for-stripe-approval',
	Rejected = 'rejected',
}
